// Code 128 barcode encoder (subsets B and C) for shipping labels. No external dependency.
// Digit runs are packed two per symbol (subset C), so numeric AWB numbers stay short and easy to scan.

const PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];
const CODE_C = 99;
const CODE_B = 100;
const START_B = 104;
const START_C = 105;
const STOP = 106;

const isDigit = (c) => c >= '0' && c <= '9';
const digitRun = (s, i) => {
  let j = i;
  while (j < s.length && isDigit(s[j])) j += 1;
  return j - i;
};

// Symbol values for the text: start code, data, checksum (no stop). Null when nothing printable is left.
export function code128Values(text) {
  const s = String(text ?? '').replace(/[^\x20-\x7e]/g, '');
  if (!s) return null;
  const vals = [];
  let i = 0;
  const first = digitRun(s, 0);
  let mode = first >= 4 || (first === 2 && s.length === 2) ? 'C' : 'B';
  vals.push(mode === 'C' ? START_C : START_B);
  while (i < s.length) {
    if (mode === 'C') {
      if (digitRun(s, i) >= 2) {
        vals.push(Number(s.slice(i, i + 2)));
        i += 2;
      } else {
        vals.push(CODE_B);
        mode = 'B';
      }
      continue;
    }
    const run = digitRun(s, i);
    if (run >= 6 || (run >= 4 && i + run === s.length)) {
      if (run % 2 === 1) {
        vals.push(s.charCodeAt(i) - 32);
        i += 1;
      }
      vals.push(CODE_C);
      mode = 'C';
      continue;
    }
    vals.push(s.charCodeAt(i) - 32);
    i += 1;
  }
  let sum = vals[0];
  for (let k = 1; k < vals.length; k += 1) sum += vals[k] * k;
  vals.push(sum % 103);
  return vals;
}

// Bars as [x, width] in modules, plus the total width in modules (without quiet zones).
export function code128Bars(text) {
  const vals = code128Values(text);
  if (!vals) return null;
  const widths = [...vals, STOP].map((v) => PATTERNS[v]).join('');
  const bars = [];
  let x = 0;
  for (let k = 0; k < widths.length; k += 1) {
    const w = Number(widths[k]);
    if (k % 2 === 0) bars.push([x, w]);
    x += w;
  }
  return { bars, width: x };
}
